import { useNavigate } from "react-router-dom";
import { getAuthToken } from "../functions/getAuthToken";
import { useEffect } from "react";
import { checkTokenAndRefresh } from "../functions/checkTokenAndRefresh";

export const useAuthInterval = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkInterval = 30000; // 30 seconds
    const authInfo: any = getAuthToken();
    let timerId: any;

    if (authInfo) {
      checkTokenAndRefresh();
      timerId = setInterval(() => {
        checkTokenAndRefresh();
      }, checkInterval);
    } else {
      navigate("/");
      timerId = setInterval(() => {}, checkInterval);
    }

    return () => {
      // localStorage.clear();
      clearInterval(timerId);
    };
  }, [navigate]);
};
